"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = void 0;
var helper_1 = require("./helper");
function validate(deckCode) {
    if (!deckCode || !deckCode.length) {
        return false;
    }
    var _a = deckCode.split("_"), headerCode = _a[0], domainCode = _a[1], formatCode = _a[2], encodedLibraryIds = _a[3], rest = _a.slice(4);
    if (!headerCode ||
        !domainCode ||
        !formatCode ||
        !encodedLibraryIds ||
        rest.length) {
        return false;
    }
    if (headerCode !== "GU") {
        return false;
    }
    if (!helper_1.isStringNumeric(domainCode)) {
        return false;
    }
    if (!helper_1.isStringNumeric(formatCode)) {
        return false;
    }
    var encodedLibraryIdChunks = helper_1.chunkString(encodedLibraryIds, 3);
    if (!encodedLibraryIdChunks) {
        return false;
    }
    return true;
}
exports.validate = validate;
